<template lang="pug">
span.heatmap-report-help
  a.heatmap-report-help__issue(
    :href='issueHref',
    target='_blank',
    rel='noopener noreferrer',
    aria-label='ヒートマップが表示されない時'
  )
    span.heatmap-report-help__issue-icon !
    span.heatmap-report-help__issue-text ヒートマップが表示されない時
  button.heatmap-report-help__howto(
    type='button',
    @click='openOnboarding'
  )
    span.heatmap-report-help__howto-icon ?
    span.heatmap-report-help__howto-text 簡単な使い方を見る
    span.heatmap-report-help__howto-chevron >
  heatmap-onboarding-modal(ref='onboarding', :seen='seen')
</template>

<script>
import HeatmapOnboardingModal from './modals/heatmap_onboarding_modal.vue'
import { HEATMAP_ONBOARDING_ISSUE_HREF } from '../constants/heatmap_onboarding_slides'

export default {
  name: 'HeatmapReportHelp',
  components: {
    HeatmapOnboardingModal
  },
  props: {
    seen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      issueHref: HEATMAP_ONBOARDING_ISSUE_HREF
    }
  },
  methods: {
    openOnboarding() {
      this.$refs.onboarding.open()
    }
  }
}
</script>

<style lang="scss" scoped>
.heatmap-report-help {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  gap: 10px;
  margin-left: 12px;
}

.heatmap-report-help__issue,
.heatmap-report-help__howto {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px 0 6px;
  border-radius: 999px;
  background: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  text-decoration: none;
  white-space: nowrap;
}

.heatmap-report-help__issue {
  border: 2px solid #e53935;
  color: #e53935;

  &:hover,
  &:focus {
    color: #c62828;
    text-decoration: none;
  }
}

.heatmap-report-help__issue-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #e53935;
  color: #fff;
  font-size: 12px;
}

.heatmap-report-help__howto {
  border: 2px solid #2fbf71;
  color: #2fbf71;
  cursor: pointer;

  &:hover,
  &:focus {
    color: #26a861;
    outline: none;
  }
}

.heatmap-report-help__howto-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #2fbf71;
  color: #fff;
  font-size: 12px;
}

.heatmap-report-help__howto-chevron {
  font-weight: 700;
}
</style>
